import { useModal } from "@/features/modal/ModalStackManager";
import { useStandardLayout } from "@/features/standardLayout/Context";
import { Calendar, isCalendarDate } from "@/features/ui/Calendar";
import { ActionIcon, Flex, Table, TextInput, Title } from "@mantine/core";
import { IconCalendar } from "@tabler/icons-react";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

interface HeaderControlsProps {
  searchInputRefs: React.MutableRefObject<{ [key: string]: HTMLInputElement | null }>;
  filterQueries: { [key: string]: string };
  handleFilterChange: (e: any) => void;
}

export const HeaderControls = (params: HeaderControlsProps) => {
  const { searchInputRefs, filterQueries, handleFilterChange } = params;
  const { startDate, endDate, setStartDate, setEndDate, setPage, setSelectedRows } =
    useStandardLayout();
  const { t } = useTranslation();
  const { openModal } = useModal();

  return (
    <>
      <Flex w="100%" p="xs" justify="center" gap="xs" align="center">
        <Title size="h1" weight={700}>
          {dayjs(startDate).format("YYYY-MM-DD")} ~ {dayjs(endDate).format("YYYY-MM-DD")}
        </Title>
        <ActionIcon
          onClick={() =>
            openModal(
              <Calendar dates={[startDate, endDate]} type="range" />,
              null,
              t("workButton.dateSelect"),
            ).then((result) => {
              if (isCalendarDate(result)) {
                const [start, end] = result;
                setStartDate(start);
                setEndDate(end);
                setPage(1);
                setSelectedRows((): Set<any> => new Set());
              }
            })
          }
        >
          <IconCalendar size="2rem" />
        </ActionIcon>
      </Flex>
      <Table>
        <thead>
          <tr>
            <th>{t("equipment.name")}</th>
            <th>{t("item.name")}</th>
            <th>{t("item.code")}</th>
            <th>{t("item.spec")}</th>
            <th>{t("workLog.workId")}</th>
            <th>{t("workLog.worker")}</th>
            <th>{t("lot.name")}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            {Object.keys(filterQueries).map((key) => (
              <td key={key}>
                <TextInput
                  ref={(el) => {
                    searchInputRefs.current[key] = el;
                  }}
                  placeholder={key}
                  name={key}
                  value={filterQueries[key]}
                  onChange={handleFilterChange}
                />
              </td>
            ))}
          </tr>
        </tbody>
      </Table>
    </>
  );
};
